module.exports = __webpack_public_path__ + "static/media/trial-neo.d06d4807.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/trial-neo.png
// module id = 179
// module chunks = 6